import { Button, Modal, FormControl, Select, MenuItem } from '@mui/material';
import Loading from 'components/Loading';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { COLOR } from 'utils/constants/color';
import SentryWrap from 'components/Sentry';

const ParentLogin = ({
  loginAsParentModal,
  setLoginAsParentModal,
  parentLoginUser,
  setParentLoginUser,
  loginasLoader,
  loginAsParent,
}) => {
  const [selectedParent, setSelectedParent] = useState(null);
  
  useEffect(() => {
    if(parentLoginUser) {
      setSelectedParent(parentLoginUser[0].parent_id);
    }
  }, [parentLoginUser]);
  
  const handleParentChange = (event) => {
    const selectedId = event.target.value;
    setSelectedParent(selectedId);
  };

  const handleLoginAsParent = () => {
    loginAsParent(selectedParent);
  };

  return (
    <SentryWrap>
      <Modal open={loginAsParentModal} onClose={() => setLoginAsParentModal(false)}>
      <ModalContent>
        You will login as{' '}
        <FormControl size="small" sx={{ minWidth: 200, margin: '0 8px' }}>
          <Select
            value={selectedParent || ''}
            onChange={handleParentChange}
            displayEmpty
            renderValue={(val) => {
              if (!val) return 'Select Parent';
              const parent = parentLoginUser.find(p => p.parent_id === val);
              return parent ? `${parent.firstName} ${parent.lastName} (parent)` : 'Select Parent';
            }}
          >
            {Array.isArray(parentLoginUser) && parentLoginUser.map((parent) => (
              <MenuItem key={parent.parent_id} value={parent.parent_id}>
                {parent.firstName} {parent.lastName} (parent)
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        any changes you make will be APPLIED to this account.
        <ModalRow>
          <Button
            className="studentLoginCanel"
            onClick={() => {
              setLoginAsParentModal(false);
              setParentLoginUser(null);
              setSelectedParent(null);
            }}
          >
            Cancel
          </Button>
          <Button disabled={!selectedParent} color="primary" variant="contained" onClick={handleLoginAsParent}>
            {loginasLoader ? <Loading size={20} white /> : 'Login as Parent'}
          </Button>
        </ModalRow>
        </ModalContent>
      </Modal>
    </SentryWrap>
  );
};

export default ParentLogin;

const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 320px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;

const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;